import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTypography } from "../../../components/CustomTypography/CustomTypography";
import { CustomIconButton } from "../../../components/CustomIconButton/CustomIconButton";
import { CustomTypographyLabelValue } from "../../../components/CustomTypographyLabelValue/CustomTypographyLabelValue";
import { Icon } from "../../../components/Icon/Icon";
import { colors } from "../../../styles/colors";
import { useGetOneCompanie } from "../../../api/companies";
import {
  getCurrentFleetId,
  isFleetAdmin,
} from "../../../utils/getCurrentFleet";
import { ModalUpdateCompany } from "./ModalUpdateCompany/ModalUpdateCompany";
import useStyles from "./styles";

export const CompanyInformation = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const companyId = getCurrentFleetId();
  const { companie } = useGetOneCompanie(companyId);
  const [openEdit, setOpenEdit] = useState(false);
  const canEdit = isFleetAdmin();

  return (
    <div className={classes.divCompanyInformation}>
      <ModalUpdateCompany
        open={openEdit}
        company={companie}
        onClose={() => setOpenEdit(false)}
      />

      <div className={classes.header}>
        <CustomTypography
          text={t("setting.companyInformation", "Company information")}
          variant={"h3"}
          isUppercase
        />
        {canEdit && (
          <CustomIconButton
            iconName={"pencil"}
            widthIcon={"30px"}
            heightIcon={"30px"}
            onClick={() => setOpenEdit(true)}
          />
        )}
      </div>

      <div className={classes.body}>
        <div className={classes.logoBox}>
          {companie?.logo ? (
            <img
              src={companie.logo}
              alt={t("setting.companyLogo", "Company logo") as string}
              className={classes.logoImg}
            />
          ) : (
            <Icon
              name={"photo"}
              width={"36px"}
              height={"36px"}
              color={colors.greydark}
            />
          )}
        </div>

        <div className={classes.infos}>
          <CustomTypographyLabelValue
            label={t("setting.companyName", "Company name")}
            value={companie?.name || "-"}
          />
          <CustomTypographyLabelValue
            label={t("setting.registrationId", "Registration number")}
            value={companie?.registration_id || "-"}
            isUppercaseValue={false}
          />
        </div>
      </div>
    </div>
  );
};
